var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "photo-lower-bar-button-group" }, [
    _c(
      "div",
      {
        staticClass: "photo-lower-bar-button",
        on: {
          click: function($event) {
            return _vm.switchVisibilityBackgroundPlanes()
          }
        }
      },
      [
        _c("SVGEye", { staticClass: "lb-svg" }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v("Скрыть/Показать плоскости")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        staticClass: "photo-lower-bar-button",
        on: {
          click: function($event) {
            return _vm.deleteSelectedPoint()
          }
        }
      },
      [
        _c("SVGPhotoDelete", { staticClass: "lb-svg" }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v("Удалить точку")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }